import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=419ea7cc&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419ea7cc')) {
      api.createRecord('419ea7cc', component.options)
    } else {
      api.reload('419ea7cc', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=419ea7cc&", function () {
      api.rerender('419ea7cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledgeimprovement/Index.vue"
export default component.exports